import { render, staticRenderFns } from "./yaml.vue?vue&type=template&id=321b8a2d&scoped=true&"
import script from "./yaml.vue?vue&type=script&lang=js&"
export * from "./yaml.vue?vue&type=script&lang=js&"
import style0 from "./yaml.vue?vue&type=style&index=0&id=321b8a2d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b8a2d",
  null
  
)

export default component.exports